import React, { Fragment } from "react"

import KnowledgeListItem from "../../../common/knowledge-list/KnowledgeListItem"
import KnowledgeListItemShadow from "../../../common/knowledge-list/KnowledgeListItemShadow"
import KnowledgeLinkButton from "../../../common/knowledge-list/KnowledgeLinkButton"
import expandableItem from "../../../common/ExpandableItem"

const ExpandableKnowledgeListItem = expandableItem(
    ({ toggleExpansion, ...article }) => (
        <KnowledgeListItem
            onClick={() => toggleExpansion}
            toggleExpansion={toggleExpansion}
            expansionLinkComponent={({ id, link }) => (
                <Fragment>
                    <KnowledgeLinkButton
                        link={`/knowledge/${id}`}
                        text="Edit article in Dashboard"
                    />
                    <KnowledgeLinkButton link={link} />
                </Fragment>
            )}
            {...article}
        />
    )
)

const ClusterViewItemArticles = ({ articles, isFetching }) => (
    <div className="widget">
        <h3 className="widget-header">
            <span className="icon icon-insights" />
            Headline article
        </h3>
        <div
            className="widget-content list-group items-list cluster-related-items-list"
            style={{ marginBottom: "20px" }}
        >
            {isFetching ? (
                <KnowledgeListItemShadow />
            ) : (
                <Fragment>
                    {(articles || [])
                        .filter(({ is_headline }) => is_headline)
                        .map(article => (
                            <ExpandableKnowledgeListItem
                                key={article.id}
                                showApproved={true}
                                {...article}
                            />
                        ))}
                    {(!articles || !articles.length) && <p>No articles</p>}
                </Fragment>
            )}
        </div>
        <h3 className="widget-header">
            <span className="icon icon-insights" />
            Other articles
        </h3>
        <div className="widget-content list-group items-list cluster-related-items-list">
            {isFetching ? (
                [0, 1].map(index => <KnowledgeListItemShadow key={index} />)
            ) : (
                <Fragment>
                    {(articles || [])
                        .filter(({ is_headline }) => !is_headline)
                        .map(article => (
                            <ExpandableKnowledgeListItem
                                key={article.id}
                                showApproved={true}
                                {...article}
                            />
                        ))}
                    {(!articles || !articles.length) && <p>No articles</p>}
                </Fragment>
            )}
        </div>
    </div>
)

export default ClusterViewItemArticles
